import{useRef as r}from"react";const useConst=t=>{const e=r();if(void 0!==e.current)return e.current;const n=t();return e.current=n,n};useConst.displayName="useConst";export{useConst as default};
//# sourceMappingURL=useConst.js.map
